"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowContentHeader = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
function WorkflowContentHeader(props) {
    var children = props.children, title = props.title;
    return (react_1.default.createElement("header", { style: { marginBottom: 40 } },
        react_1.default.createElement(core_ui_1.Padding, { x: 40, top: 40 },
            react_1.default.createElement(core_ui_1.Stack, { gap: 8, direction: "vertical" },
                react_1.default.createElement(core_ui_1.Title, { size: 24, weight: 400 }, title),
                children && react_1.default.createElement("div", null, children)))));
}
exports.WorkflowContentHeader = WorkflowContentHeader;
